module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-item"
  }, [_c('div', {
    staticClass: "item-avatar f-fl"
  }, [_c('div', {
    staticClass: "bg-d"
  }, [_c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.webp(_vm.item.userIcon) + ')'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_c('main-item', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), (_vm.showReply) ? _c('div', {
    staticClass: "reply-block"
  }, [_c('span', {
    staticClass: "triangle-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "triangle-up-shadow"
  }), _vm._v(" "), _vm._l((_vm.item.replies), function(replyItem, index) {
    return _c('reply-item', {
      key: replyItem.id,
      attrs: {
        "open-reply-status": _vm.openReplyStatus,
        "open-reply-handle": _vm.openReplyHandle,
        "item": replyItem,
        "index": index,
        "count": _vm.replyCount
      }
    })
  })], 2) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d61cfd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/comment-item.vue
// module id = 855
// module chunks = 2